<div style="height: 100%">
	<ng-content></ng-content>
</div>